import type { ReplaceWithParams } from './String.types';

/**
 * @description
 * Mask user input. Replaces using a regex
 */
const replaceValue = ({ value, regex, replaceWith = '' }: ReplaceWithParams): string =>
  value.replace(regex, replaceWith);

export default replaceValue;
export const replaceWValueParameter = (url: string, value: string, separator: string): string => {
  const regExp = /[&?]w=[0-9]+/g;

  if (regExp.test(url)) {
    return url.replace(regExp, `${separator}w=${value}`);
  }

  return url;
};
